// @flow
import consts from "common/consts";
import { asAbsolute } from "root/routes/utils";
import CropView from "..";

export default [{
	path: asAbsolute(consts.CROP),
	component: CropView,
	routes: [],
}];
